export default "__VITE_ASSET__76502257__"